import { commonUploadFileApi } from "@/api/common";

export function uploadFile(e, options) {
  const file = e.file;
  const { onSuccess, context, domainId = "default" } = options;
  
  // 处理文件名，去掉+号
  let fileName = file.name.replace(/\+/g, '');
  // 创建一个新的File对象，使用处理后的文件名
  let newFile = new File([file], fileName, { type: file.type });

  commonUploadFileApi(newFile).then(response => {
    console.log('上传成功:', response.data.data);
    
    if (response.data && typeof onSuccess === 'function') {
      onSuccess.call(context, response.data.data);
    }
  }).catch((error) => {
    console.error('文件上传失败:', error);
    context.$message({ type: 'error', message: "上传失败" });
  });
}